<template>
  <span class="currency b lr ac">
    <img
      v-if="type == 'gold'"
      src="../../assets/images/common/currency.png"
      alt="熊猫豆"
    />
    <img
      v-if="type == 'longzhu'"
      src="../../assets/images/common/longzhu.png"
      alt="龙珠币"
    />
    {{ displayText }}
  </span>
</template>

<script>
import { mapState } from 'vuex';
// 金额展示统一走全局格式化（与 h5 utils/payment/format.js 同口径）
import { formatMoney } from '@/utils';
export default {
  props: {
    text: null,
    // 需要固定小数位时传 2（合计 / 费用这类要对齐的场景），默认去尾零
    decimals: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      type: 'gold'
    };
  },
  mounted() {
    // this.init();
  },
  methods: {
    init() {
      this.type = this.config.currency;
    }
  },
  watch: {
    config: {
      handler(val) {
        if (val && Object.keys(val) > 1) {
          this.type = val.currency;
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('common', ['config']),
    // 金额/积分按统一口径展示；非数值（''、'--'、'10~20'、未取到价格）
    // 原样输出，避免把“还没有值”显示成 0
    displayText() {
      const { text, decimals } = this;
      const isNumberLike =
        (typeof text === 'number' || typeof text === 'string') &&
        text !== '' &&
        isFinite(Number(text));
      if (!isNumberLike) return text;
      return formatMoney(text, decimals);
    }
  }
};
</script>

<style lang="scss" scoped>
.currency {
  color: $color-primary;
  font-size: 14px;
  img {
    width: 10px;
    height: auto;
    margin-right: 6px;
  }
}
</style>
